document.addEventListener('DOMContentLoaded', function () {
    const variantPicker = document.querySelector('variant-picker');
    const countdownElement = document.getElementById('countdown-timer');
    const shippingDateInput = document.getElementById('shipping-date-property');
const shippingNoteInput = document.getElementById('shipping-note-property');
    let countdownInterval;
    let variantStatuses = [];

    const style = document.createElement('style');
    style.textContent = `
      .flashing-dot {
        display: inline-block;
        margin-right: 3px;
        color: blue;
        animation: flash 2s infinite;
      }

      @keyframes flash {
        0%, 100% { opacity: 1; }
        50% { opacity: 0; }
      }

      .animated-soldout-text {
        display: inline-block;
        animation: fadeSlideIn 0.5s ease-out;
      }

      @keyframes fadeSlideIn {
        0% {
          opacity: 0;
          transform: translateY(8px);
        }
        100% {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `;
    document.head.appendChild(style);

    // Get the alternate message from the data attribute
    const alternateShippingMessage = countdownElement ? countdownElement.dataset.alternateMessage : '';

    function formatShippingDate(date) {
        return date.toLocaleDateString('en-US', { 
            month: 'long', 
            day: 'numeric'
        });
    }

    /**
     * Gets current Pacific time components and the offset needed to convert
     * "Pacific-as-local" dates to actual timestamps.
     */
    function getPacificTimeInfo() {
        const now = new Date();
        
        // Get Pacific time components
        const pacificString = now.toLocaleString('en-US', {
            timeZone: 'America/Los_Angeles',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        });
        
        // Parse: "MM/DD/YYYY, HH:MM:SS"
        const [datePart, timePart] = pacificString.split(', ');
        const [month, day, year] = datePart.split('/').map(Number);
        const [hours, minutes, seconds] = timePart.split(':').map(Number);
        
        // Create a local Date object using Pacific time values
        // This gives us the day of week and lets us do date math
        const pacificAsLocal = new Date(year, month - 1, day, hours, minutes, seconds);
        
        // The offset is the difference between the actual current time and
        // what we'd get if Pacific time values were local time values.
        // Add this offset to any "Pacific-as-local" date to get the real timestamp.
        const offset = now.getTime() - pacificAsLocal.getTime();
        
        return {
            year,
            month: month - 1, // 0-indexed for Date constructor
            day,
            hours,
            minutes,
            seconds,
            dayOfWeek: pacificAsLocal.getDay(),
            offset,
            asLocalDate: pacificAsLocal
        };
    }

    /**
     * Checks if a given date (year, month 1-indexed, day) is a holiday.
     */
    function isHolidayByComponents(year, month, day) {
        const dateString = year + '-' + 
            String(month).padStart(2, '0') + '-' + 
            String(day).padStart(2, '0');
        return shippingHolidays.includes(dateString);
    }

    /**
     * Checks if a "Pacific-as-local" Date object falls on a holiday.
     */
    function isHolidayByDate(date) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1; // Convert to 1-indexed
        const day = date.getDate();
        return isHolidayByComponents(year, month, day);
    }

    /**
     * Given a "Pacific-as-local" Date, returns the next business day
     * as a "Pacific-as-local" Date (same time of day).
     */
    function getNextBusinessDay(pacificDate) {
        let nextDate = new Date(pacificDate.getTime());
        nextDate.setDate(nextDate.getDate() + 1);
        
        while (
            nextDate.getDay() === 0 || // Sunday
            nextDate.getDay() === 6 || // Saturday
            isHolidayByDate(nextDate)
        ) {
            nextDate.setDate(nextDate.getDate() + 1);
        }
        return nextDate;
    }

    /**
     * Checks if a "Pacific-as-local" Date is a valid shipping day
     * (not a weekend, not a holiday).
     */
    function isValidShippingDay(pacificDate) {
        return pacificDate.getDay() !== 0 && 
               pacificDate.getDay() !== 6 && 
               !isHolidayByDate(pacificDate);
    }

    /**
     * Calculates the next cutoff time as an absolute timestamp.
     * This is the moment (in real time) when the shipping cutoff occurs.
     */
    function calculateNextCutoffTime() {
        const pacific = getPacificTimeInfo();
        
        // Start with today's cutoff in Pacific time (as a local Date)
        let cutoffPacificAsLocal = new Date(pacific.year, pacific.month, pacific.day, shippingCutoffTime, 0, 0, 0);
        
        // Determine if we need to move to the next business day:
        // - If current Pacific time is past today's cutoff
        // - If today is a weekend
        // - If today is a holiday
        const isPastCutoff = pacific.hours >= shippingCutoffTime;
        const isWeekend = pacific.dayOfWeek === 0 || pacific.dayOfWeek === 6;
        const isTodayHoliday = isHolidayByComponents(pacific.year, pacific.month + 1, pacific.day);
        
        if (isPastCutoff || isWeekend || isTodayHoliday) {
            // Move to next business day's cutoff
            cutoffPacificAsLocal = getNextBusinessDay(pacific.asLocalDate);
            cutoffPacificAsLocal.setHours(shippingCutoffTime, 0, 0, 0);
        }
        
        // Convert from "Pacific-as-local" to actual absolute timestamp
        return new Date(cutoffPacificAsLocal.getTime() + pacific.offset);
    }

    /**
     * Returns the shipping date as a "Pacific-as-local" Date object.
     * This is used for display purposes (showing the weekday, month, day).
     */
    function getShippingDate() {
        const pacific = getPacificTimeInfo();
        
        // Check if we can ship today:
        // - Must be before cutoff
        // - Must be a valid shipping day
        const isBeforeCutoff = pacific.hours < shippingCutoffTime;
        const isTodayValid = isValidShippingDay(pacific.asLocalDate);
        
        if (isBeforeCutoff && isTodayValid) {
            // Ships today
            return new Date(pacific.year, pacific.month, pacific.day);
        }
        
        // Otherwise, ships next business day
        return getNextBusinessDay(pacific.asLocalDate);
    }

    function toggleCountdownVisibility(show) {
        if (countdownElement) {
            countdownElement.style.display = show ? 'block' : 'none';
        }
    }

    function stopCountdown() {
        if (countdownInterval) {
            clearInterval(countdownInterval);
            countdownInterval = null;
        }
    }

    function startCountdown() {
        const cutoffTime = calculateNextCutoffTime();

        function updateCountdown() {
            // Use actual current timestamp for comparison
            const now = new Date().getTime();
            const distance = cutoffTime.getTime() - now;

            if (distance > 0) {
                const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((distance % (1000 * 60)) / 1000);

                let countdownText = '';
                if (days > 0) {
                    countdownText += `${days}d `;
                }
                countdownText += `${hours}h ${minutes}m ${seconds}s`;

                // Get shipping date for display (this is a "Pacific-as-local" date)
                const shippingDate = getShippingDate();
                const pacific = getPacificTimeInfo();

                // Format the shipping date
                let shippingDateFormatted;
                
                // Create "today" and "tomorrow" as Pacific dates for comparison
                const todayPacific = new Date(pacific.year, pacific.month, pacific.day);
                const tomorrowPacific = new Date(pacific.year, pacific.month, pacific.day + 1);

                const isSameDay = (date1, date2) => {
                    return date1.getFullYear() === date2.getFullYear() &&
                           date1.getMonth() === date2.getMonth() &&
                           date1.getDate() === date2.getDate();
                };
                
                if (isSameDay(shippingDate, todayPacific)) {
                    shippingDateFormatted = `Today, ${shippingDate.toLocaleDateString('en-US', {
                        month: 'long',
                        day: 'numeric'
                    })}`;
                } else if (isSameDay(shippingDate, tomorrowPacific) && isValidShippingDay(tomorrowPacific)) {
                    shippingDateFormatted = `Tomorrow, ${shippingDate.toLocaleDateString('en-US', {
                        month: 'long',
                        day: 'numeric'
                    })}`;
                } else {
                    shippingDateFormatted = shippingDate.toLocaleDateString('en-US', {
                        weekday: 'long',
                        month: 'long',
                        day: 'numeric'
                    });
                }

// Construct the message
                let message = `<span style="color: green;"><b>In Stock</b></span><br>Ships <strong>${shippingDateFormatted}.</strong><br>Order in the next <span style="color: green;">${countdownText}</span>`;
                
                // Add alternate shipping message if it exists
                if (alternateShippingMessage && alternateShippingMessage.trim() !== '') {
                    message += `<br><div style="background-color: #28a745; color: white; padding: 5px 5px; border-radius: 0px; line-height: 1.2; margin-top: 5px; display: inline-block;">${alternateShippingMessage}</div>`;
                } 
                if (shippingDateInput) {
                    shippingDateInput.value = formatShippingDate(shippingDate);
                }

                countdownElement.innerHTML = message;
            } else {
                // Cutoff passed, recalculate for next business day
                const nextShippingDay = getShippingDate();
                countdownElement.innerHTML = "Ships same day or next business day.";
                if (shippingDateInput) {
                    shippingDateInput.value = formatShippingDate(nextShippingDay);
                }
                
                // Restart countdown with new cutoff time
                stopCountdown();
                startCountdown();
            }
        }

        stopCountdown();
        updateCountdown();
        countdownInterval = setInterval(updateCountdown, 1000);
    }

    function loadVariantStatuses() {
        const productData = variantPicker ? variantPicker.data.product : null;

        if (!productData || !productData.variants) return;

        variantStatuses = productData.variants.map(variant => {
            const isPreOrder = variant.inventory_quantity <= 0 && variant.available === true;
            const isOutOfStock = variant.inventory_quantity <= 0 && variant.available === false;
            const shippingTimerText = document.querySelector(`[data-variant-metafield="${variant.id}"]`)?.value;
            const soldOutText = document.querySelector(`[data-variant-sold-out-text="${variant.id}"]`)?.value;

            return {
                title: variant.title,
                inventory_quantity: variant.inventory_quantity,
                isPreOrder: isPreOrder,
                isOutOfStock: isOutOfStock,
                shippingTimerText: shippingTimerText,
                soldOutText: soldOutText
            };
        });
    }

    function checkAndToggleCountdown() {
        if (!variantPicker) return;

        const selectedVariant = variantPicker.getSelectedOptions();
        const variant = variantStatuses.find(v =>
            v.title === selectedVariant.join(' / ')
        );

        if (!variant) return;

        stopCountdown();

        setTimeout(() => {
            const preOrderMessageElement = document.querySelector('[data-pre-order-message]');
            let preOrderMessage = preOrderMessageElement ? preOrderMessageElement.textContent : '';

            if (variant.shippingTimerText && variant.shippingTimerText.trim() !== '') {
    countdownElement.innerHTML = `<span style="color: green;"><b>In Stock</b></span><br>${variant.shippingTimerText}`;
    countdownElement.style.display = 'block';
    if (shippingNoteInput) shippingNoteInput.value = variant.shippingTimerText;
    return;
}

            if (preOrderMessage.startsWith("Preorder: ")) {
                preOrderMessage = preOrderMessage.replace("Preorder: ", "");
            }

if (variant.isPreOrder && preOrderMessage) {
                countdownElement.innerHTML = `<span style="color: #00008B;"><b>Preorder</b></span><br>${preOrderMessage}<br>&nbsp;`;
                if (shippingDateInput) {
                    const preOrderDate = new Date(preOrderMessage);
                    if (!isNaN(preOrderDate.getTime())) {
                        shippingDateInput.value = formatShippingDate(preOrderDate);
                    } else {
                        shippingDateInput.value = preOrderMessage;
                    }
                }
                if (shippingNoteInput) shippingNoteInput.value = '';
                countdownElement.style.display = 'block';
            } else if (!variant.isPreOrder && variant.inventory_quantity > 0) {
                if (shippingNoteInput) shippingNoteInput.value = '';
                startCountdown();
                countdownElement.style.display = 'block';
            } else if (variant.isOutOfStock) {
                let soldOutMessage = `<span style="color: #D2042D;"><b>Sold Out</b></span>`;
 
                if (variant.soldOutText && variant.soldOutText.trim() !== '') {
                    soldOutMessage += `
                        <br><span class="animated-soldout-text">
                          <span class="flashing-dot">●</span>
                          <b>${variant.soldOutText}</b>
                        </span>
                        <br>Use the link below to be notified when it's back`;
                } else {
                    soldOutMessage += `<br>Use the link below to be notified when it's back<br>&nbsp;`;
                }

                countdownElement.innerHTML = soldOutMessage;
                if (shippingDateInput) {
                    shippingDateInput.value = '';
                }
                countdownElement.style.display = 'block';
            } else {
                countdownElement.style.display = 'none';
            }
        }, 50);
    }

    if (variantPicker) {
        loadVariantStatuses();
        setTimeout(checkAndToggleCountdown, 100);

        variantPicker.addEventListener('change', () => {
            checkAndToggleCountdown();
        });
    } else {
        startCountdown();
    }
});